import React from 'react'
import { MutatingDots, RotatingLines, ThreeCircles } from 'react-loader-spinner'

const Loading = ({ height, width, colorClass }) => {
    return (
        <div id="cover-spin" className='loading_card'>
            <RotatingLines
                visible={true}
                height={height || "40"}
                width={width || "40"}
                color={colorClass || "#001F3D"}
                strokeColor={colorClass || "#001F3D"}
                strokeWidth="5"
                animationDuration="0.75"
                ariaLabel="rotating-lines-loading"
                wrapperStyle={{
                }}

                wrapperClass="bg-transparent"
            />
        </div >
    )
}

export const IconLoading = ({ height, width }) => {
    return (<div id="cover-spin" className=''>

        <ThreeCircles
            visible={true}
            height={height}
            width={width}
            strokeColor="white"
            animationDuration="0.75"
            color="white"
            ariaLabel="three-circles-loading"
            wrapperStyle={{
                backgroundColor: "transparent"
            }}
            wrapperClass="bg-transparent"
        />

    </div>)
}

export default Loading